var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecure = function SvgSecure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.847 2.015.004-.002a.741.741 0 0 1 .604.002l5.248 2.332c.27.12.447.392.447.688V8.56c0 3.782-2.583 7.294-6 8.225-3.417-.931-6-4.443-6-8.225V5.035c0-.296.177-.567.447-.688l5.25-2.332Z",
    stroke: "#58B847",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#58B847",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    d: "M9.15 8.68v3.3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.15,
    cy: 6.16,
    r: 0.75,
    fill: "#58B847"
  })));
};
export default SvgSecure;